import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import { Autocomplete, Box, Button, Container, Grid, Paper, TextField, Typography, FormControl, InputLabel, Select, TextFieldProps } from "@mui/material";

//@ts-ignore
import InputMask from 'react-input-mask';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Alert from '@mui/material/Alert';
import SpinnerCarregando from '../../../components/Controls/SpinnerCarregando';
import Backdrop from '@mui/material/Backdrop';
import TelefonesTable from '../../../components/TelefonesTable';

//@ts-ignore
// import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import api from "../../../services/api";
import FornecedoresCredoresSocios from "../../../components/FornecedoresCredoresSocios";
import { validarCNPJ, replaceAll, validaChaveDeAcessoNotaFiscal } from "../../../utils/functions";

import MenuItem from '@mui/material/MenuItem';

import { uuidv4, formatCNPJ } from '../../../utils/functions'

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import ptBRLocale from 'date-fns/locale/pt-BR';

import XmlButton from '../../PrestacaoDeContas/ComprovantesDeDespesas/ComprovantesDeDespesasEditInsert/XmlButton';

import SelectComponent from '../../../components/Controls/SelectComponent';

// import ItensNotasFiscaisRecibos from '../../../components/Controls/ItensNotasFiscaisRecibos';

import ItensNotasFiscaisRecibosList  from '../../../components/ItensNotasFiscaisRecibosList';

const useStyles = makeStyles((theme) => ({
  box: {
    height: 60,
    display: "flex",
    border: "",
    padding: 0
  },
  topLeftBox: {
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  centerBox: {
    justifyContent: "center",
    alignItems: "center"
  },
  bottomRightBox: {
    justifyContent: "flex-end",
    alignItems: "center"
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  valorTotal: {
    backgroundColor : "#F5F5F5",
    borderColor: "primary"
  }
}));

export default function DataFunction () {
  const query = useParams();
  const history = useHistory();
  const classes = useStyles();

  const [rows, setRows] = React.useState([]);

  const [initialValues, setInitialValues] = React.useState({});

  const [backdrop, setBackdrop] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState('success');
  const [message, setMessage] = React.useState('Dados gravados com sucesso!');

  const [bairroDistrito, setBairroDistrito] = useState('');
  const [cep, setCep] = React.useState("");
  const [cnpj, setCnpj] = React.useState(null);
  const [cidadesId, setCidadesId] = React.useState(null);
  const [cidadesList, setCidadesList] = React.useState([]);
  const [endereco, setEndereco] = React.useState("");
  const [estadosId, setEstadosId] = React.useState(null);
  const [estadosList, setEstadosList] = React.useState([]);
  const [fornecedoresCredoresSituacaoId, setFornecedoresCredoresSituacaoId] = React.useState(null);
  const [fornecedoresCredoresSituacaoList, setFornecedoresCredoresSituacaoList] = React.useState([]);
  const [numero, setNumero] = React.useState("");
  const [complemento, setComplemento] = React.useState("");
  const [nomeFantasia, setNomeFantasia] = React.useState("");
  const [nomeRazaoSocial, setNomeRazaoSocial] = React.useState("");
  const [nomeRazaoSocialNomeFantasia, setNomeRazaoSocialNomeFantasia] = React.useState("");
  const [situacao, setSituacao] = React.useState("");
  const [inscricaoMunicipal, setInscricaoMunicipal] = React.useState("");
  const [inscricaoEstadual, setInscricaoEstadual] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [site, setSite] = React.useState("");
  const [socios, setSocios] = React.useState([]);
  const [sociosGroup, setSociosGroup] = React.useState("");
  const [telefones, setTelefones] = React.useState(null);

  const [tipoNotaFiscal, setTipoNotaFiscal] = React.useState([]);
  const [tiposComprovantesDeDespesasList, setTiposComprovantesDeDespesasList] = React.useState([]);
  const [chaveDeAcesso, setChaveDeAcesso] = React.useState(null);
  const [dataEmissao, setDataEmissao] = React.useState(null);
  const [dataPagamento, setDataPagamento] = React.useState(null);
  const [dataCompensacaoChequeTransferencia, setDataCompensacaoChequeTransferencia] = React.useState(null);
  const [numeroChequeOrdemPagamento, setNumeroChequeOrdemPagamento] = React.useState(null);
  const [tiposComprovantesDeDespesasId, setTiposComprovantesDeDespesasId] = React.useState(null);
  const [tiposComprovantesDeDespesas, setTiposComprovantesDeDespesas] = React.useState(null);

  const [especiesId, setEspeciesId] = React.useState(null);
  const [meiosDePagamentosList, setMeiosDePagamentosList] = React.useState([]);
  const [meiosDePagamentosId, setMeiosDePagamentosId] = React.useState(null);
  const [valorTotal, setValorTotal] = React.useState(null);

  useEffect(() => {
    // @ts-ignore
    if (query.id) {
      // @ts-ignore
      const values = api.get(`fornecedores-credores/${query.id}`)
      values.then((response) => {
        const nomeRazaoSocialNomeFantasia = setNomeRazaoSocialNomeFantasia(response.data.nomeRazaoSocial);
        if (response.data.nomeFantasia) {
          //@ts-ignore
          nomeRazaoSocialNomeFantasia = setNomeRazaoSocialNomeFantasia(response.data.nomeRazaoSocial + "/" + response.data.nomeFantasia);
        }
        setInitialValues(response.data);
        setCep(response.data.cep);
        setCnpj(response.data.cnpj);
        setBairroDistrito(response.data.bairroDistrito);
        setEndereco(response.data.endereco);
        // setNumero(response.data.numero);
        setComplemento(response.data.complemento);
        setNomeRazaoSocial(response.data.nomeRazaoSocial);
        setNomeFantasia(response.data.nomeFantasia);
        //@ts-ignore
        setNomeRazaoSocialNomeFantasia(nomeRazaoSocialNomeFantasia);
        setInscricaoMunicipal(response.data.inscricaoMunicipal);
        setInscricaoEstadual(response.data.inscricaoEstadual);
        setEmail(response.data.email);
        setSite(response.data.site);
        setSocios(response.data.socios);
        setTelefones(response.data.telefones);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      })
    } else {
      setNewRegister();
    }
  }, []);

  useEffect(() => {
      // @ts-ignore
      const values = api.get(`estados`)
      values.then((response) => {
        setEstadosList(response.data)
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      })
  }, []);

  useEffect(() => {
    setErrors([]);
    
    //@ts-ignore
    if (cnpj && cnpj.replace(/\D/g, '').length === 14 && !validarCNPJ(cnpj)) {
      
    //@ts-ignore
      setErrors(['cnpj']);
      //@ts-ignore
    } else if (cnpj && cnpj.replace(/\D/g, '').length === 14 && validarCNPJ(cnpj)) {
    //@ts-ignore
      getCNPJData(cnpj.replace(/\D/g, ''));
    } 
    //@ts-ignore
    if (!cnpj || (cnpj.replace(/\D/g, '').length < 14)) {
      clearData();
    }
}, [cnpj]);

const getCidadesPorEstado = () => {
  setCidadesList([]);
  //@ts-ignore
  if (estadosId && estadosId.id) {
    //@ts-ignore
    const values = api.get(`cidades/por-estado/${estadosId.id}`)
    values.then((response) => {
      setCidadesList(response.data)
    })
    .catch((err) => {
      console.error("ops! ocorreu um erro" + err);
    })
  }
}
  useEffect(() => {
    getCidadesPorEstado();
  }, [estadosId]);

  useEffect(() => {
    setNewRegister();
    //@ts-ignore
    if (query.id) {
      // @ts-ignore
      const values = api.get(`fornecedores-credores/${query.id}`)
      values.then((response) => {
        setInitialValues(response.data);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      })
    }
  }, []);

  React.useEffect(() => {
    const values = api.get("itens")
     values.then((response) => {
       setRows(response.data)
     })
     .catch((err) => {
       console.error("ops! ocorreu um erro" + err);
     })
   }, []);
 
  useEffect(() => {
    // @ts-ignore
    const values = api.get(`fornecedores-credores-situacao`)
    values.then((response) => {
      setFornecedoresCredoresSituacaoList(response.data);
    })
    .catch((err) => {
      console.error("ops! ocorreu um erro" + err);
    })
  }, []);

  useEffect(() => {
    // @ts-ignore
    const values = api.get(`tipos-comprovantes-de-despesas`)
    values.then((response) => {
      setTiposComprovantesDeDespesasList(response.data);
    })
    .catch((err) => {
      console.error("ops! ocorreu um erro" + err);
    })
  }, []);

  useEffect(() => {
    //@ts-ignore
    setCidadesId(cidadesList.find(item => item.value === initialValues.cidadesId));
  }, [cidadesList]);

  useEffect(() => {
    //@ts-ignore
    setEstadosId(estadosList.find(item => item.value === initialValues.estadosId));
  }, [estadosList]);

  useEffect(() => {
    //@ts-ignore
    setFornecedoresCredoresSituacaoId(fornecedoresCredoresSituacaoList.find(item => item.value === initialValues.fornecedoresCredoresSituacaoId));
  }, [fornecedoresCredoresSituacaoList]);

  const [errors, setErrors] = React.useState([]);

  const handleClickAlert = () => {
    setOpen(true);
  };

  // @ts-ignore
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  // const Alert = React.forwardRef(function Alert(props, ref) {
  //   // @ts-ignore
  //   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  // });

   const createNewRegister = () => {
    history.push('/fornecedores-credores/new');
    setNewRegister();
  }

  const clearData = () => {
    setBairroDistrito('');
    setEndereco('');
    setNumero('');
    setComplemento('');
    setNomeRazaoSocial('data.nome');
    setNomeFantasia('');
    setNomeRazaoSocialNomeFantasia('');

    //@ts-ignore
    setSituacao([]);

    getFornecedoresCredoresSituacaoId([])
    // setInscricaoMunicipal(response.data.inscricaoMunicipal);
    // setInscricaoEstadual(response.data.inscricaoEstadual);
    setEmail('');
    setSocios([]);
    setSociosGroup('');

    getNumerosTelefones('');

    setCep('');
    setInitialValues({ ...initialValues,
      'bairroDistrito': '',
      'endereco': '',
      'numero': '',
      'complemento': '',
      'nomeRazaoSocial': '',
      'nomeFantasia': '',
      'email': ''
    })
  }

  //@ts-ignore
  const getEndereco = (cep) => {
    fetch(`https:/viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        // setEndereco(data.logradouro);
        // setBairroDistrito(data.bairro);
        if (data.ibge) {
          const values = api.get(`cidades/por-cidade-codigo/${data.ibge}`)
          values.then((response) => {
            //@ts-ignore
            setEstadosId(estadosList.find(item => item.value === response.data[0].estadosId));
            setInitialValues({ ...initialValues, 'estadoId': response.data[0].estadosId })
            getCidadesPorEstado();
            setTimeout(function () {
              //@ts-ignore
              setCidadesId(cidadesList.find(item => item.value === response.data[0].id));
              setInitialValues({ ...initialValues, 'estadoId': response.data[0].id })
            }, 1000);
          })
          .catch((err) => {
            console.error("ops! ocorreu um erro" + err);
          })
        }
      })
  }

  //@ts-ignore
  const getFornecedoresCredoresSituacaoId = (fornecedoresCredoresSituacaoId) => {
    //@ts-ignore
    setFornecedoresCredoresSituacaoId(fornecedoresCredoresSituacaoList.find(item => item.label === fornecedoresCredoresSituacaoId));
  }

  //@ts-ignore
  const getSocios = (socios) => {
    if (socios) {
      //@ts-ignore
      socios.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
    }
    setSocios(socios);
    // console.log("socios: ", socios);
  }

  //@ts-ignore
  const getSociosGroup = (socios) => {
    if (socios) {
      //@ts-ignore
      socios.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
    }
    let sociosGroup = ""
    //@ts-ignore
    sociosGroup = socios.map(n => {
      return n.nome
    });
    setSociosGroup(sociosGroup);
  }
  //@ts-ignore
  const getNumerosTelefones = (telefones) => {
    let retorno = replaceAll(telefones, ' ', '')
    retorno = replaceAll(retorno, '-', '')
    retorno = retorno.split('/');
    //@ts-ignore
    const array = [];
    //@ts-ignore
    retorno.map(item => (
      array.push({
        'ddd': item.substr(1,2),
        'numero': item.substr(4),
      })
    ))
    //@ts-ignore
    setTelefones(array);
  }

  //@ts-ignore
  const getCNPJData = (cnpj) => {
    // fetch(`http://www.receitaws.com.br/v1/cnpj/${cnpj}`)
    fetch(`https://api.allorigins.win/raw?url=http://www.receitaws.com.br/v1/cnpj/${cnpj}`)
      .then((res) => res.json(
      ))
      .then((data) => {
        // setInitialValues(response.data);
        // setCnpj(response.data.cnpj);
        setBairroDistrito(data.bairro);
        setEndereco(data.logradouro);
        // setNumero(data.numero);
        setComplemento(data.complemento);
        setNomeRazaoSocial(data.nome);
        setNomeFantasia(data.nomeFantasia);
        setNomeRazaoSocialNomeFantasia(data.nome);

          if (data.nomeFantasia) {
            setNomeRazaoSocialNomeFantasia(data.nome + "/" + data.nome);
          }

        setSituacao(data.situacao);

        getFornecedoresCredoresSituacaoId(data.situacao)
        // setInscricaoMunicipal(response.data.inscricaoMunicipal);
        // setInscricaoEstadual(response.data.inscricaoEstadual);
        setEmail(data.email);
        getSocios(data.qsa);
        getSociosGroup(data.qsa);

        getNumerosTelefones(data.telefone);

        setCep(data.cep);
        if (data.cep && data.cep.replace(/\D/g, '').length === 8) {
          getEndereco(data.cep.replace(/\D/g, ''));
        }
        setInitialValues({ ...initialValues,
          'bairroDistrito': data.bairro,
          'endereco': data.logradouro,
          'numero': data.numero,
          'complemento': data.complemento,
          'nomeRazaoSocial': data.nome,
          'nomeFantasia': data.nomeFantasia,
          'email': data.email })
      })
  }

  //@ts-ignore
  const testCNPJ = (cnpj) => {
    return (cnpj && cnpj.replace(/\D/g, '').length === 14 && validarCNPJ(cnpj));
  }

  const checkErrors = () => {
    const dado = [];
    //@ts-ignore
    if (!bairroDistrito || !bairroDistrito.length > 5) {
      dado.push('bairroDistrito');
    } 
    if (!cep || cep.replace(/\D/g, '').length !== 8) {
      dado.push('cep')
    }
    //@ts-ignore
    if (!cidadesId || !cidadesId.id) {
      dado.push('cidadesId')
    }
    //@ts-ignore
    if (!estadosId || !estadosId.id) {
      dado.push('estadosId')
    }
    if (!cnpj || !validarCNPJ(cnpj)) {
      dado.push('cnpj')
    }
    if (!endereco || endereco.length <= 4) {
      dado.push('endereco');
    } 
    if (!numero || numero.length < 1) {
      dado.push('numero');
    }
    if (!nomeRazaoSocial || nomeRazaoSocial.length <= 9) {
      dado.push('nomeRazaoSocial');
    }
    //@ts-ignore
    if (!fornecedoresCredoresSituacaoId || !fornecedoresCredoresSituacaoId.id) {
      dado.push('fornecedoresCredoresSituacaoId');
    }
    // if (!nomeFantasia || nomeFantasia.length <= 9) {
    //   dado.push('nomeFantasia');
    // }
    // if (!inscricaoMunicipal || inscricaoMunicipal.length <= 4) {
    //   dado.push('inscricaoMunicipal');
    // }
    // if (!inscricaoEstadual || inscricaoEstadual.length <= 4) {
    //   dado.push('inscricaoEstadual');
    // }
    const reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; 
    if (!email || !reg.test(email)) {
      dado.push('email');
    } 
    // const regUrl = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    // if (!site || !regUrl.test(site)) {
    //   dado.push('site');
    // } 
    // console.log('dado: ', dado);
    //@ts-ignore
    setErrors(dado);

    if (dado.length === 0) {
      saveUpdateData();
    }
  }

  const saveUpdateData = () => {
    const data = initialValues;
    const payload = {
      'bairroDistrito': bairroDistrito.toUpperCase(),
      'cep': cep.replace(/\D/g, ''),
      //@ts-ignore
      'cidadesId': cidadesId && cidadesId.id ? cidadesId.id : null,
      //@ts-ignore
      'cnpj': cnpj ? cnpj.replace(/\D/g, '') : '',
      'complemento': complemento.toUpperCase(),
      'email': email.toLowerCase(),
      'endereco': endereco.toUpperCase(),
      //@ts-ignore
      'estadosId': estadosId.id,
      //@ts-ignore
      'id': data.id,
      'inscricaoEstadual': inscricaoEstadual,
      'inscricaoMunicipal': inscricaoMunicipal,
      'nomeFantasia': nomeFantasia ? nomeFantasia.toUpperCase() : '',
      'nomeRazaoSocial': nomeRazaoSocial.toUpperCase(),
      'numero': numero.toUpperCase(),
      'site': site,
      'fornecedoresCredoresSituacaoId': fornecedoresCredoresSituacaoId,
      'socios': socios
    }

    //@ts-ignore
    if (!query.id) {
      delete payload.id;
    } 

    // @ts-ignore
    const values = query.id ? api.put(`fornecedores-credores/${data.id}`, payload) : api.post(`fornecedores-credores`, payload)
    values.then((response) => {
      setBackdrop(false);
      handleClickAlert();
    })
    .catch((err) => {
      setMessage('Erro ao gravar os dados! Verifique!');
      setBackdrop(false);
      setSeverity('error');
      handleClickAlert();
      console.error("ops! ocorreu um erro" + err);
    })
  }

  const setNewRegister = () => {
    const newValues = {
      "bairroDistrito": "",
      "cep": "",
      "cidadesCodigo": "",
      "cidadesId": null,
      "cidadesNome": "",
      "cnpj": "",
      "complemento": "",
      "email": "",
      "endereco": "",
      "enderecoCompleto": "",
      "estadosAbreviacao": "",
      "estadosCodigo": "",
      "estadosId": "",
      "estadosNome": "",
      "id": "",
      "inscricaoEstadual": "",
      "inscricaoMunicipal": "",
      "nomeFantasia": "",
      "nomeRazaoSocial": "",
      "numero": "",
      "pais": "",
      "site": "",
      "socios": [],
      "telefonesNumeros": [],
      "vendedores": [],
      "vendedoresNomes": "",
      "fornecedoresCredoresSituacaoId": null
    }
    setBairroDistrito("");
    setCep("");
    setCidadesId(null);
    //@ts-ignore
    setCnpj("");
    setComplemento("");
    setEmail("");
    setEndereco("");
    setEstadosId(null);
    // 'id': data.id,
    setInscricaoEstadual("");
    setInscricaoMunicipal("");
    setNomeFantasia("");
    setNomeRazaoSocial("");
    setNumero("");
    setSite("");
    setFornecedoresCredoresSituacaoId(null);
    // setSocios([]);

    setInitialValues(newValues);
  }

  //@ts-ignore
  const handleChange = (event) => {
    setTipoNotaFiscal(event.target.value);
  }
  
  //@ts-ignore
  const handleTiposComprovantesDeDespesas = (value) => {
    setTiposComprovantesDeDespesas(value.label);
    setInitialValues({...initialValues, 'tiposComprovantesDeDespesasId': value});
  }

  //@ts-ignore
  const handleEspecie = (value) => {
    // console.log("value2: ", value);
    //@ts-ignore
    setNumero(null);
    setDataEmissao(null);
    setEspeciesId(value);

    const tiposComprovantesDeDespesasId = {
      "abreviacao": "NF",
      "id": "62df2c67-3670-11ec-bc9c-00155d5484f1",
      "label": "NOTA FISCAL",
      "value": "62df2c67-3670-11ec-bc9c-00155d5484f1"
    };


    //@ts-ignore
    setTiposComprovantesDeDespesas('');
    setTiposComprovantesDeDespesasId(null);

    if (value) {
      handleTiposComprovantesDeDespesas(tiposComprovantesDeDespesasId);
      setInitialValues({...initialValues, 'tiposComprovantesDeDespesasId': value});
    }

    setInitialValues({...initialValues, 'especie': value})
  }

  //@ts-ignore
  const handleMeiosDePagamentos = (value) => {
    // console.log("value: ", value);
  }

  //@ts-ignore
  const checkChaveDeAcesso = (chaveDeAcesso) => {
    if (chaveDeAcesso && chaveDeAcesso.replace(/[^\d]+/g,'').length === 44 && !validaChaveDeAcessoNotaFiscal(chaveDeAcesso)) {
      return true;
    }
    return false;
  }

  const itens = [{
    "id": null,
    "quantidadeComercial": null,
    "descricao": null,
    "valorUnitario": null,
    "valorTotal": null,
    // "desconto": null,
    // "origemDosRecursosId": null,
    "comprovantesDeDespesasId": null,
    "tiposRecursosId": null,
    "unidadesDeMedidasId": null,
    "new": null
  }];
  
  //@ts-ignore
  // function NumberFormatCustom(props) {
  //   const { inputRef, onChange, ...other } = props;
  
  //   return (
  //     //@ts-ignore
  //     <NumberFormat
  //       {...other}
  //       getInputRef={inputRef}
  //       //@ts-ignore
  //       onValueChange={values => {
  //         onChange({
  //           target: {
  //             name: props.name,
  //             value: values.value
  //           }
  //         });
  //       }}
  //       thousandSeparator
  //       // isNumericString
  //     />
  //   );
  // }

  //@ts-ignore
  const handleInsertItem = (itemNotasFiscaisRecibos) => {
    // console.log("itemNotasFiscaisRecibos5555: ", itemNotasFiscaisRecibos);
    const newRows = [];
    const newItem = {
      "ordem": itemNotasFiscaisRecibos.ordem,
      "id": uuidv4(),
      "quantidadeComercial": itemNotasFiscaisRecibos.quantidadeComercial,
      "descricao": itemNotasFiscaisRecibos.descricao.toUpperCase(),
      "valorUnitario": parseFloat(itemNotasFiscaisRecibos.valorUnitario).toLocaleString('pt-BR',{ minimumFractionDigits: 2 }),
      "valorTotal": itemNotasFiscaisRecibos.valorTotal,
      "desconto": itemNotasFiscaisRecibos.desconto,
      "unidadesDeMedidasId": itemNotasFiscaisRecibos.unidadesDeMedidasId.id,
      "unidadesDeMedidasDescricao": itemNotasFiscaisRecibos.unidadesDeMedidasId.descricao,
      "unidadesDeMedidasAbreviacao": itemNotasFiscaisRecibos.unidadesDeMedidasId.abreviacao,
      // "origemDosRecursosId": itemNotasFiscaisRecibos.origemDosRecursosId,
      // "origemDosRecursosDescricao": itemNotasFiscaisRecibos.origemDosRecursosId.descricao,
      // "origemDosRecursosAbreviacao": itemNotasFiscaisRecibos.origemDosRecursosId.abreviacao,
      "tiposRecursosId": itemNotasFiscaisRecibos.tiposRecursosId.id,
      "tiposRecursosDescricao": itemNotasFiscaisRecibos.tiposRecursosId.label,
      "tiposRecursosAbreviacao": itemNotasFiscaisRecibos.tiposRecursosId.abreviacao,
      "comprovantesDeDespesasId": itemNotasFiscaisRecibos.comprovantesDeDespesasId,
      "new": null
    };

    let newOrder = 1;
    rows.forEach(item => {
      //@ts-ignore
      item.ordem = newOrder;
      //@ts-ignore
      item.new = false;
      newRows.push(item);
      newOrder++;
    })
    newItem.ordem = newOrder;
    //@ts-ignore
    newItem.new = true;
    newRows.push(newItem);
    
    //@ts-ignore
    setRows(newRows);
    // console.log('rows aqui: ', newRows)
    // setRows(newItem);
  }

  //@ts-ignore
  const handleDeleteItem = (selecteds) => {
    // alert('Delete Item Aqui!!!');

    // console.log('selecteds: ', selecteds);
    // console.log('rows: ', rows);

    const newRows = rows.filter(
      //@ts-ignore
      item => !selecteds.includes(item.id)
    );

    setRows(newRows);
  }

  //@ts-ignore
  const handleChangeOrdem = (data, value) => {
    //@ts-ignore
    const newRows = [];

    rows.forEach(item => {
      //@ts-ignore
      if (item.id === data.id) {
        // selecteds.push(item.id);
        //@ts-ignore
        item.ordem = value;
      }
      // item.new = false;
      // item.quantidadeComercial = 99;
      newRows.push(item);
    })
    
    //@ts-ignore
    setRows(newRows);
  }

  const handleOrder = () => {
    //@ts-ignore
    const newRows = [];
    // @ts-ignore
    const newR = rows.sort((a,b) => (a.ordem > b.ordem) ? 1 : ((b.ordem > a.ordem) ? -1 : 0));
    let i = 1;
    //@ts-ignore
    newR.forEach(item => {
      //@ts-ignore
      item.ordem = i;
      newRows.push(item);
      i++;
    })
    //@ts-ignore
    setRows(newRows);
  }

  return (
    <Container maxWidth="xl">
      {/* <pre>{JSON.stringify(cnpj, null, 2)}</pre> */}
      <Typography component="div" style={{ height: '100vh - 48px' }}>
        <Paper elevation={3}sx={{ px: 5, pb: 5, m: 4, display: 'flex', flexDirection: 'column' }}>
          <SpinnerCarregando open={backdrop} />
          <Snackbar open={open} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ 'vertical': 'top', 'horizontal': 'center' }}>
          <Alert
            // onClose={() => {handleClose}}
            //@ts-ignore
            severity={severity}
            sx={{ width: '100%' }}>
              {message}
          </Alert>

          </Snackbar>
              <>
                <Grid container spacing={2}  sx={{ mt: 3 }}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ ml: 2 }}
                  >
                    <Box>
                      <Typography component="div">
                        <Box sx={{ fontWeight: 'light', fontSize: 20, color: '#A9A9A9' }}>Comprovantes de Despesas - Edição</Box>
                      </Typography> 
                    </Box>

                    <Box
                      component="div"
                      className={`${classes.bottomRightBox} ${classes.box}`}>
                        <div>
                          <Button onClick={history.goBack} variant="outlined" color="primary" size="small" style={{ height: 35, marginRight: 20}}>
                            Cancelar
                          </Button>
                        </div>

                        <div style={{ height: 35, marginRight: 20}}>
                          <XmlButton />
                        </div>

                        <div>
                          <Button type="reset" onClick={createNewRegister} variant="outlined" color="primary" size="small" style={{ height: 35, marginRight: 20}} disabled={false}>
                            Novo
                          </Button>
                        </div>

                        <div>
                          <Button type="submit" onClick={checkErrors} variant="outlined" color="primary" size="small" style={{ height: 35 }} disabled={false}>
                            Gravar
                          </Button>
                        </div>
                    </Box>
                  </Grid>

                  <Grid container spacing={2}  sx={{ ml: 2, mt: 1}}>
                    <Box>
                      <Typography component="div">
                        <Box sx={{ fontWeight: 'light', fontSize: 20, color: '#A9A9A9' }}>Fornecedor</Box>
                      </Typography> 
                    </Box>
                  </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>

                  <TextField
                    value={cnpj}
                    type="tel"
                    required
                    focused
                    fullWidth
                    inputProps={{ readOnly: false }}
                    size="small"
                    label={("CNPJ")}
                    onChange={e => {
                      //@ts-ignore
                      setCnpj(formatCNPJ(e.target.value))
                      setInitialValues({...initialValues, 'cnpj': e.target.value})
                      }
                    }
                    //@ts-ignore
                    error={errors.includes('cnpj')}
                    //@ts-ignore
                    helperText={errors.includes('cnpj') ? 'Campo incorreto!' : ''} />


                    {/*
                    <InputMask
                      mask="99.999.999/9999-99"
                      value={cnpj}
                      //@ts-ignore
                      onChange={e => {
                          setCnpj(e.target.value)
                          setInitialValues({...initialValues, 'cnpj': e.target.value})
                        }
                      }
                      onBlur={cnpj}
                    >
                      {(inputProps: Props): ReactElement => (
                        <TextField
                          {...inputProps}
                          type="tel"
                          required
                          focused
                          fullWidth
                          size="small"
                          label={("CNPJ")}
                          //@ts-ignore
                          error={errors.includes('cnpj')}
                          //@ts-ignore
                          helperText={errors.includes('cnpj') ? 'Campo incorreto!' : ''}
                        />
                      )}
                    </InputMask>

                    */}
                  </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <TextField
                      size="small"
                      value={situacao}
                      disabled={!testCNPJ(cnpj)}
                      required
                      type="tel"
                      focused
                      fullWidth
                      label={("Situação")}
                      inputProps={{ style: { textTransform: "uppercase" }, readOnly: true }}
                      onChange={e => {
                          setSituacao(e.target.value)
                          setInitialValues({...initialValues, 'situacao': e.target.value})
                        }
                      }
                      //@ts-ignore
                      error={errors.includes('fornecedoresCredoresSituacaoId')}
                      //@ts-ignore
                      helperText={errors.includes('fornecedoresCredoresSituacaoId') ? 'Campo obrigatório!' : ''}
                    />
                  </Grid>
                    
                  <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                    <TextField
                      size="small"
                      value={nomeRazaoSocialNomeFantasia}
                      disabled={!testCNPJ(cnpj)}
                      required
                      type="tel"
                      focused
                      fullWidth
                      label={("Razão Social/Nome Fantasia")}
                      inputProps={{ style: { textTransform: "uppercase" }, readOnly: true }}
                      onChange={e => {
                          setNomeRazaoSocial(e.target.value)
                          setInitialValues({...initialValues, 'nomeRazaoSocial': e.target.value})
                        }
                      }
                      //@ts-ignore
                      error={errors.includes('nomeRazaoSocial')}
                      //@ts-ignore
                      helperText={errors.includes('nomeRazaoSocial') ? 'Campo obrigatório!' : ''}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextField
                      size="small"
                      value={sociosGroup}
                      disabled={!testCNPJ(cnpj)}
                      required
                      type="tel"
                      focused
                      fullWidth
                      label={("Sócios")}
                      inputProps={{ style: { textTransform: "uppercase" }, readOnly: true }}
                      onChange={e => {
                          // setSociosGroup(e.target.value)
                          // setInitialValues({...initialValues, 'sociosGroup': e.target.value})
                        }
                      }
                      //@ts-ignore
                      error={errors.includes('sociosGroup')}
                      //@ts-ignore
                      helperText={errors.includes('sociosGroup') ? 'Campo obrigatório!' : ''}
                    />
                  </Grid>
                  
                  <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <SelectComponent
                      disabled={!testCNPJ(cnpj)}
                      nLabel="Espécie"
                      newWidth="100%"
                      variant="outlined"
                      apiConst="especies"
                      nDisabled={!testCNPJ(cnpj)}
                      onSelectData={handleEspecie}
                      nRequired="true" />
                  </Grid>

                  <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    {//@ts-ignore
                    especiesId &&
                    //@ts-ignore
                    especiesId.id === "a35fce1c-11e9-11ec-833c-dc41a970c8d9" ?
                    <SelectComponent
                      disabled={!testCNPJ(cnpj)}
                      nLabel="Tipos Comprovantes de Despesas"
                      newWidth="100%"
                      variant="outlined"
                      apiConst="tipos-comprovantes-de-despesas"
                      nDisabled={!testCNPJ(cnpj)}
                      nRequired="true"
                      onSelectData={handleTiposComprovantesDeDespesas}
                      onChange={handleTiposComprovantesDeDespesas} />
                      : <>
                        <TextField
                        size="small"
                        value={tiposComprovantesDeDespesas}
                        disabled={!testCNPJ(cnpj)}
                        required
                        type="tel"
                        focused
                        fullWidth
                        label={("Tipos Comprovantes de Despesas")}
                        inputProps={{ style: { textTransform: "uppercase" }, readOnly: true }}
                        // onChange={e => {
                        //     // setSociosGroup(e.target.value)
                        //     // setInitialValues({...initialValues, 'sociosGroup': e.target.value})
                        //   }
                        // }
                        // error={errors.includes('sociosGroup')}
                        // helperText={errors.includes('sociosGroup') ? 'Campo obrigatório!' : ''}
                    />
                      
                      </>}
                  </Grid>

                  <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <SelectComponent
                      disabled={!testCNPJ(cnpj)}
                      nLabel="Meio de Pagamento"
                      newWidth="100%"
                      variant="outlined"
                      apiConst="meios-de-pagamentos"
                      nDisabled={!testCNPJ(cnpj)}
                      nRequired="true"
                      onSelectData={handleMeiosDePagamentos} />
                  </Grid>

                  
                  { //@ts-ignore
                  (false &&
                    //@ts-ignore
                    (especiesId.id == "09c7031c-3732-11ec-bc9c-00155d5484f1" || 
                  //@ts-ignore
                  especiesId.id == "9e80506b-11e9-11ec-833c-dc41a970c8d9")) ?
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    
                    <TextField
                      value={chaveDeAcesso}
                      // disabled={!testCNPJ(cnpj)}
                      type="tel"
                      required
                      focused
                      fullWidth
                      inputProps={{ readOnly: true, maxLength: 44 }}
                      size="small"
                      label={("Chave de Acesso (Nota Fiscal)")}
                      onChange={e => {
                        //@ts-ignore
                        setChaveDeAcesso(e.target.value)
                          setInitialValues({...initialValues, 'chaveDeAcesso': e.target.value})
                        }
                      }
                      //@ts-ignore
                      error={errors.includes('chaveDeAcesso') || checkChaveDeAcesso(chaveDeAcesso)}
                      //@ts-ignore
                      helperText={errors.includes('chaveDeAcesso') || checkChaveDeAcesso(chaveDeAcesso) ? 'Campo incorreto!' : ''} />
                  {/*
                    <InputMask
                      mask="9999 9999 9999 9999 9999 9999 9999 9999 9999 9999 9999"
                      value={chaveDeAcesso}
                      disabled={!testCNPJ(cnpj)}
                      //@ts-ignore
                      onChange={e => {
                        setChaveDeAcesso(e.target.value)
                        setInitialValues({...initialValues, 'chaveDeAcesso': e.target.value})
                        }
                      }
                      onBlur={chaveDeAcesso}
                    >
                      {(inputProps: Props): ReactElement => (
                        <TextField
                          {...inputProps}
                          type="tel"
                          required
                          focused
                          fullWidth
                          disabled={!testCNPJ(cnpj)}
                          size="small"
                          //@ts-ignore
                          label={("Chave de Acesso (Nota Fiscal)")}
                          //@ts-ignore
                          error={errors.includes('chaveDeAcesso') || checkChaveDeAcesso(chaveDeAcesso)}
                          //@ts-ignore
                          helperText={errors.includes('chaveDeAcesso') || checkChaveDeAcesso(chaveDeAcesso) ? 'Campo incorreto!' : ''}
                        />
                      )}
                    </InputMask>

                    */}
                  </Grid>
                  : <> </>}

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <TextField
                      size="small"
                      value={numero}
                      // disabled={!testCNPJ(cnpj)}
                      required
                      type="tel"
                      focused
                      fullWidth
                      className="valorTotal"
                      label={("Nº Nota Fiscal/Recibo")}
                      inputProps={{ style: { textTransform: "uppercase", backgroundColor: "#E1EBEE" },
                        maxLength: 20,
                        //@ts-ignore
                        // readOnly: !especiesId || especiesId.id == "09c7031c-3732-11ec-bc9c-00155d5484f1" ||
                        //@ts-ignore
                        // especiesId.id == "9e80506b-11e9-11ec-833c-dc41a970c8d9"
                      }}
                      onChange={e => {
                          setNumero(e.target.value)
                          setInitialValues({...initialValues, 'numero': e.target.value})
                        }
                      }
                      //@ts-ignore
                      error={errors.includes('numeroChequeOrdemPagamento')}
                      //@ts-ignore
                      helperText={errors.includes('numeroChequeOrdemPagamento') ? 'Campo obrigatório!' : ''}
                    />
                  </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBRLocale}>
                      <DatePicker
                        label="Data emissao"
                        value={dataEmissao}
                        // disabled={!testCNPJ(cnpj)}
                        //@ts-ignore
                        inputProps={{ style: { backgroundColor: "#E1EBEE" } }}
                        onChange={(newValue: string | number | React.SetStateAction<null> | Date) => {
                          // @ts-ignore
                          setDataEmissao(newValue);
                          // errors.pessoaDataNascimento = true;
                          if (newValue) {
                            // @ts-ignore
                            let formatDate = new Date(newValue);
                            // @ts-ignore
                            // formatDate = formatDate.setDate(formatDate.getDate() + 1);
                            // formatDate = new Date(formatDate);
                            const newFormatDate = (formatDate.getFullYear()) + "-" + (formatDate.getMonth() + 1) + "-" + (formatDate.getDate());
                            // @ts-ignore
                            // initialValues.pessoaDataNascimento = newFormatDate;
                            // errors.pessoaDataNascimento = false;
                          }
                        }}
                        renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) =>
                          <TextField
                          {...params}
                          size="small"
                          fullWidth
                          focused
                          required
                          inputProps={{ style: { textTransform: "uppercase", backgroundColor: "#E1EBEE" },
                          maxLength: 20,
                          //@ts-ignore
                          readOnly: !especiesId || especiesId.id == "09c7031c-3732-11ec-bc9c-00155d5484f1" ||
                          //@ts-ignore
                          especiesId.id == "9e80506b-11e9-11ec-833c-dc41a970c8d9" }}
                          //@ts-ignore
                          error={errors.includes('dataEmissao')}
                          //@ts-ignore
                          helperText={errors.includes('dataEmissao') ? 'Campo obrigatório incorreto!' : ''}
                        />}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <TextField
                      size="small"
                      value={numeroChequeOrdemPagamento}
                      // disabled={!testCNPJ(cnpj)}
                      required
                      type="tel"
                      focused
                      fullWidth
                      className="valorTotal"
                      label={("Nº Cheque/Ordem Pagamento")}
                      inputProps={{ style: { textTransform: "uppercase" }, maxLength: 20 }}
                      onChange={e => {
                        //@ts-ignore
                          setNumeroChequeOrdemPagamento(e.target.value)
                          setInitialValues({...initialValues, 'numeroChequeOrdemPagamento': e.target.value})
                        }
                      }
                      //@ts-ignore
                      error={errors.includes('numeroChequeOrdemPagamento')}
                      //@ts-ignore
                      helperText={errors.includes('numeroChequeOrdemPagamento') ? 'Campo obrigatório!' : ''}
                    />
                  </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBRLocale}>
                      <DatePicker
                        label="Data pagamento"
                        value={dataPagamento}
                        // disabled={!testCNPJ(cnpj)}
                        onChange={(newValue: string | number | React.SetStateAction<null> | Date) => {
                          // @ts-ignore
                          setDataPagamento(newValue);
                          // errors.pessoaDataNascimento = true;
                          if (newValue) {
                            // @ts-ignore
                            let formatDate = new Date(newValue);
                            // @ts-ignore
                            // formatDate = formatDate.setDate(formatDate.getDate() + 1);
                            // formatDate = new Date(formatDate);
                            const newFormatDate = (formatDate.getFullYear()) + "-" + (formatDate.getMonth() + 1) + "-" + (formatDate.getDate());
                            setInitialValues({...initialValues, "dataPagamento": newValue});
                            // @ts-ignore
                            // initialValues.pessoaDataNascimento = newFormatDate;
                            // errors.pessoaDataNascimento = false;
                          }
                        }}
                        renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) =>
                          <TextField
                          {...params}
                          size="small"
                          fullWidth
                          focused
                          required
                          //@ts-ignore
                          error={errors.includes('dataPagamento')}
                          //@ts-ignore
                          helperText={errors.includes('dataPagamento') ? 'Campo obrigatório incorreto!' : ''}
                        />}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBRLocale}>
                    <DatePicker
                      label="Data compensação"
                      value={dataCompensacaoChequeTransferencia}
                      // disabled={!testCNPJ(cnpj)}
                      onChange={(newValue: string | number | React.SetStateAction<null> | Date) => {
                        // @ts-ignore
                        setDataCompensacaoChequeTransferencia(newValue);
                        // errors.pessoaDataNascimento = true;
                        if (newValue) {
                          // @ts-ignore
                          let formatDate = new Date(newValue);
                          // @ts-ignore
                          // formatDate = formatDate.setDate(formatDate.getDate() + 1);
                          // formatDate = new Date(formatDate);
                          const newFormatDate = (formatDate.getFullYear()) + "-" + (formatDate.getMonth() + 1) + "-" + (formatDate.getDate());
                          setInitialValues({...initialValues, "dataCompensacaoChequeTransferencia": newValue});
                          // @ts-ignore
                          // initialValues.pessoaDataNascimento = newFormatDate;
                          // errors.pessoaDataNascimento = false;
                        }
                      }}
                      renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) =>
                        <TextField
                        {...params}
                        size="small"
                        fullWidth
                        focused
                        required
                        //@ts-ignore
                        error={errors.includes('dataPagamento')}
                        //@ts-ignore
                        helperText={errors.includes('dataPagamento') ? 'Campo obrigatório incorreto!' : ''}
                      />}
                    />
                  </LocalizationProvider>
                </Grid>

                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    {/*
                    <CurrencyTextField
                      label="Valor Total"
                      size="small"
                      variant="outlined"
                      value={valorTotal}
                      outputFormat="string"
                      // minimumValue="0"
                      currencySymbol=""
                      decimalCharacter=","
                      digitGroupSeparator="."
                      defaultValue={valorTotal}
                      required
                      fullWidth
                      focused
                      // InputProps={{ style: { color: "#c15165", borderColor: "primary", borderWidth: 2 } }}
                      InputProps={{ style: { backgroundColor: "#E1EBEE" } }}
                      disabled={!testCNPJ(cnpj)}
                      //@ts-ignore
                      onChange={(event, newValue) => {
                        setInitialValues({...initialValues, 'valorTotal': newValue})
                      }}
                    />
                    */}
                  </Grid>

                  {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <ItensNotasFiscaisRecibos sx={{ mt: 5 }}/>
                  </Grid> */}
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mt: 2 }}>
                    <ItensNotasFiscaisRecibosList
                      rows={rows}
                      handleInsertItem={handleInsertItem}
                      handleDeleteItem={handleDeleteItem}
                      handleChangeOrdem={handleChangeOrdem}
                      handleOrder={handleOrder} />
                  </Grid>

              </Grid>
            </>
          {/* <FornecedoresCredoresSocios socios={socios ? socios : []} /> */}
        </Paper>
      </Typography>
    </Container>
  );
}
